// --- React & Core Dependencies
import React, { useState } from 'react';
import moment from 'moment';
// --- UI Components
import Tabs from '@dtci/spellbook/Tabs';
import Tab from '@dtci/spellbook/Tab';
import Card from '@dtci/spellbook/Card';
import Typography from '@dtci/spellbook/Typography';
import { SummaryCard } from '../details-cards/summary';
import { MetadataCard } from '../details-cards/metadata';
import { ProspectCard } from '../details-cards/prospect';
import { SpartaCard } from '../details-cards/sparta';
import { NielsenCard } from '../details-cards/nielsen';
import { LoadCard } from '../details-cards/load';

/**
 * TabsContent Component
 *
 * Renders tabbed content with product details.
 *
 * @param {Object} props - Component props.
 * @param {Object} props.details - Product details to display.
 * @returns {JSX.Element} Tabbed content with product details.
 */
export const TabsContent = ({ details }) => {
    const [activeTab, setActiveTab] = useState(0);
    const formattedCreatedDate = moment(details.createdAt).format('YYYY-MM-DD');

    const tabs = [
        { key: 'summary', title: 'SUMMARY', content: <SummaryCard details={details} /> },
        { key: 'metadata', title: 'METADATA', content: <MetadataCard details={details} /> },
        { key: 'prospect', title: 'PROSPECT', content: <ProspectCard details={details} /> },
        { key: 'sparta', title: 'SPARTA', content: <SpartaCard details={details} /> },
        { key: 'nielsen', title: 'NIELSEN', content: <NielsenCard details={details} /> },
        { key: 'load', title: 'LOAD', content: <LoadCard details={details} /> },
    ];

    return (
        <Card cardStyle="floating">
            <Typography variant="T30" bold>
                {details.title} ({details.productId})
            </Typography>
            <Typography variant="T20">
                <b>Group:</b> {details.groupTitle} ({details.groupId})
            </Typography>
            {details.episode && (
                <Typography variant="T20">
                    <b>Episode:</b> {details.episodeNum} - ({details.episodeTitle})
                </Typography>
            )}
            <Typography variant="T20">
                <b>Created:</b> {formattedCreatedDate}
            </Typography>
            <Tabs role="tablist">
                {tabs.map((tab, index) => (
                    <Tab
                        key={tab.key}
                        onClick={() => setActiveTab(index)}
                        active={index === activeTab}
                    >
                        {tab.title}
                    </Tab>
                ))}
            </Tabs>
            {tabs[activeTab].content}
        </Card>
    );
};
